import { StyledPosts } from "./styles";
import { Post } from "../Post";

type iUser = {
	id: number;
	createdAt: Date;
	updatedAt: Date;
	name: string;
	username: string;
	icon: string;
	role: "user" | "admin";
	phone: string;
	email: string;
	password: string;
	deletedAt: Date | null;
	bio?: string;
	image?: string;
};

type iPostUserImageLikeSchema = {
	count: number;
	raw: {
		id: number;
		message: string;
		like: number;
		dislike: number;
		comment: number;
		Images: {
			id: number;
			createdAt: Date;
			publicId: string;
			url: string;
			secureUrl: string;
		}[];
		User: iUser;
		createdAt: Date;
		updatedAt: Date;
	}[];
};

export const Posts = ({
	posts,
	postIdClicked,
}: {
	posts: iPostUserImageLikeSchema | null;
	postIdClicked?: number;
}) => {
	return (
		<StyledPosts>
			<div id="posts">
				{!!posts?.raw.length &&
					posts.raw.map((post, index) => {
						return <Post key={post.id} post={post} postIdClicked={postIdClicked} />;
					})}
			</div>
		</StyledPosts>
	);
};
